import './ImageCell.scss'

interface ImageCellProps {
  src: string
  width: number
  height: number
  onClick?: () => void
}

export function ImageCell(props: ImageCellProps) {
  return (
    <div className="grid-image-cell">
      <img src={props.src} width={props.width} height={props.height}/>
    </div>
  )
}
